import { integrationHookFactory } from '../integrations.hooks';
import {
    getLojaIntegradaState,
    saveLojaIntegradaIntegration, getLojaIntegradaData,
} from './loja-integrada.state';

export const useLojaIntegrada = integrationHookFactory({
    saveAction: saveLojaIntegradaIntegration,
    loadAction: getLojaIntegradaData,
    stateSelector: getLojaIntegradaState,
});
